import { createEssay } from '../../../core/queries/essays-queries/essayFunction';
import { useMutation } from '@tanstack/react-query';

export function useCreatePracticeEssay() {
  const { mutate, isPending, isError, error } = useMutation({
    mutationKey: ['createPracticeEssay'], 
    mutationFn: (body: { theme: string, moduleOrigin: string }) => createEssay(body),
    retry: false
  });

  return { mutate, isPending, isError, error };
}